// DAT myClaim Service - API Integration
// Holt DAT-Credentials automatisch vom Backend basierend auf dem eingeloggten User

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

// Helper für Auth-Header
const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    'Authorization': token ? `Bearer ${token}` : ''
  };
};

// Create or Update Contract via Backend
export const createOrUpdateContract = async (contractData, contractType = 'vro_calculation', networkType = 'DAT', invoiceRatesId = null) => {
  try {
    const response = await fetch(`${BACKEND_URL}/api/dat/contract`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify({
        contractData,
        contractType,
        networkType,
        invoiceRatesId
      })
    });

    const data = await response.json();
    
    if (!response.ok || !data.success) {
      throw new Error(data.error || data.detail || `HTTP error! status: ${response.status}`);
    }

    return data.claimId;
  } catch (error) {
    console.error('Error creating contract:', error);
    throw error;
  }
};

// Get Contract Data via Backend
export const getContract = async (claimId) => {
  try {
    const response = await fetch(`${BACKEND_URL}/api/dat/contract/${claimId}`, {
      headers: getAuthHeaders()
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error getting contract:', error);
    throw error;
  }
};

// Update Contract Calculation
export const updateContractCalculation = async (claimId, calculationData) => {
  try {
    const response = await fetch(`${BACKEND_URL}/api/dat/contract/${claimId}/calculation`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify(calculationData)
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error updating calculation:', error);
    throw error;
  }
};

// Get myClaim URL with credentials (from backend)
export const getMyClaimUrl = async (aktenzeichen, fahrzeugDaten = {}) => {
  try {
    const response = await fetch(`${BACKEND_URL}/api/dat/myclaim/generate-url`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify({
        aktenzeichen,
        hersteller: fahrzeugDaten.hersteller || fahrzeugDaten.marke,
        kennzeichen: fahrzeugDaten.kennzeichen,
        vin: fahrzeugDaten.vin
      })
    });

    const data = await response.json();
    
    if (!data.success) {
      throw new Error(data.error || 'Fehler beim Generieren der myClaim URL');
    }

    return data;
  } catch (error) {
    console.error('Error getting myClaim URL:', error);
    throw error;
  }
};

// Check if DAT credentials are configured
export const checkDatCredentials = async () => {
  try {
    const response = await fetch(`${BACKEND_URL}/api/dat/debug-credentials`, {
      headers: getAuthHeaders()
    });

    if (!response.ok) {
      return { configured: false };
    }

    const data = await response.json();
    return {
      configured: data.credentials_found,
      customerNumber: data.customer_number,
      requestor: data.requestor
    };
  } catch (error) {
    console.error('Error checking credentials:', error);
    return { configured: false };
  }
};

// Parse calculation data from API response
export const parseCalculationData = (apiResponse) => {
  if (!apiResponse) return null;

  return {
    contractId: apiResponse.contractId || apiResponse.claim_id,
    statusName: apiResponse.statusName || apiResponse.status,
    dossier: apiResponse.dossier || apiResponse.contract_data,
    vehicle: apiResponse.vehicle,
    owner: apiResponse.owner,
    calculation: {
      totalGross: parseFloat(apiResponse.calculation?.totalGross) || 0,
      totalNet: parseFloat(apiResponse.calculation?.totalNet) || 0,
      totalVat: parseFloat(apiResponse.calculation?.totalVat) || 0,
      sparePartsTotal: parseFloat(apiResponse.calculation?.sparePartsTotal) || 0,
      labourTotal: parseFloat(apiResponse.calculation?.labourTotal) || 0,
      lacquerTotal: parseFloat(apiResponse.calculation?.lacquerTotal) || 0,
      auxiliaryTotal: parseFloat(apiResponse.calculation?.auxiliaryTotal) || 0,
      smallParts: parseFloat(apiResponse.calculation?.smallParts) || 0,
      materialPositions: apiResponse.calculation?.materialPositions || [],
      labourPositions: apiResponse.calculation?.labourPositions || [],
      works: apiResponse.calculation?.works || []
    }
  };
};

export default {
  createOrUpdateContract,
  getContract,
  updateContractCalculation,
  getMyClaimUrl,
  checkDatCredentials,
  parseCalculationData
};
